import { Component, AfterViewInit  } from '@angular/core';
import {HttpClient} from "@angular/common/http";

import * as dictionary from "../../../dict/static.json";
import { DataProvider2 } from "../../provider/data2.provider";

const config: any = dictionary['config'];

@Component({
	selector: 'app-test-view',
	template: `
		<cache-date></cache-date>
		
		<hr/>
		
		<div *ngFor="let folder of images" [sextant]="'test-view-folder'">
			<div *ngFor="let subFolder of folder" class="test-view-container">
				<h3>
					{{ subFolder[0].folder }}: {{ subFolder[0].subFolder }}
				</h3>
				
				<ngb-carousel *ngIf="subFolder">
					<ng-template *ngFor="let image of subFolder" ngbSlide>
						<img
							[src]="getUrl(image)"
							class="img-fluid"
						/>
						<div class="carousel-caption" style="color: black;">
							<h3>
								{{ image.file }}
							</h3>
						</div>
					</ng-template>
				</ngb-carousel>
				
				<hr/>
			</div>
			
			<hr/>
		</div>
	`
})
export class TestViewComponent implements AfterViewInit {
	public images = [];
	
	constructor(
		public http: HttpClient,
		public dp2: DataProvider2,
	) {
		
	}
	
	getUrl(image: any) {
		return `${config.baseUrl}/test/image/${image.folder}/${image.subFolder}/${image.file}`;
	}
	
	async ngAfterViewInit() {
		const me = this;
		
		const data = await me.dp2.get('/test').toPromise();

		me.images = <string[]>data;
	}
}
